import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
  intlShape,
  injectIntl,
} from 'react-intl';

import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import { green } from '@material-ui/core/colors';

const messages = defineMessages({
  refuseDeleteBtnLabel: {
    id: 'General.refuseDeleteBtnLabel',
    defaultMessage: 'Oops! no thanks',
  },
  submitUnlockExamMsg: {
    id: 'ExamTaskResults.ConfirmUnlockDialog.submitRestoreUserMsg',
    defaultMessage:
      'Are you sure you want to  give {attempts} retries to {user} in {exam}?',
    description:
      'Message to confirm unlocking exam in unlock exam dialog window',
  },
  submitBtnLabel: {
    id: 'ExamTaskResults.ConfirmUnlockDialog.submitBtnLabel',
    defaultMessage: 'Submit',
    description: 'Button label displayed on unlock exam dialog window',
  },
});

const styles = theme => ({
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  buttonWrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fff',
    '&:hover': {
      backgroundColor: green[700],
      color: '#fff',
    },
  },
});

const ConfirmUnlockDialog = ({
  isShown,
  onClose,
  submit,
  groupActionSubmitted,
  groupActionSubmitting,
  classes,
  className,
  user,
  exam,
  attempts,
  intl: { formatMessage },
}) => (
  <Dialog
    open={isShown}
    onClose={onClose}
    classes={{ paper: className }}
    id="unlock-dialog"
  >
    <DialogTitle>
      {formatMessage(messages.submitUnlockExamMsg, {
        user,
        exam,
        attempts,
      })}
    </DialogTitle>
    <DialogActions>
      <Button data-test-id="Dp7FOoO1Yg2d2dUIOw32t" onClick={onClose}>
        <FormattedMessage {...messages.refuseDeleteBtnLabel} />
      </Button>
      <div className={classes.buttonWrapper}>
        <Button
          data-test-id="2kDU_H5DWz345GuHxNQ_x"
          id="confirm-unlocking-btn"
          onClick={submit}
          color="primary"
          variant="contained"
          disabled={groupActionSubmitting || groupActionSubmitted}
          autoFocus
          className={classNames({
            [classes.buttonSuccess]: groupActionSubmitted,
          })}
        >
          <FormattedMessage {...messages.submitBtnLabel} />
        </Button>
        {groupActionSubmitting && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </DialogActions>
  </Dialog>
);

ConfirmUnlockDialog.propTypes = {
  attempts: PropTypes.number.isRequired,
  isShown: PropTypes.bool.isRequired,
  groupActionSubmitted: PropTypes.bool.isRequired,
  groupActionSubmitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  className: PropTypes.string,
  user: PropTypes.string.isRequired,
  exam: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  classes: PropTypes.shape({
    buttonSuccess: PropTypes.shape({}),
    buttonProgress: PropTypes.shape({}),
    buttonWrapper: PropTypes.shape({}),
  }).isRequired,
};

ConfirmUnlockDialog.defaultProps = {
  className: '',
};

export default injectIntl(withStyles(styles)(ConfirmUnlockDialog));
